import * as yup from 'yup';

export const validationSchema = yup
  .object({
    code: yup.string().min(6).max(6, 'The code should be 6 digits').required('Please enter the sent code'),
  })
  .required();
